import { useState } from "react";
import type { CategoryDto, ProductDto } from "../../../shared/api-types";
import { normalizeForSearch } from "../../../shared/slug";
import { menuApi } from "../../api/queries";
import { useToast } from "../../components/Toast";

// Verifică → "Produse congelate" (owner 2026-11-03): the restaurant ticks every dish made from a frozen product;
// the public menu says so. One tick = one draft change, published with the menu.

export function FrozenChecklist({
  rid,
  menuId,
  categories,
  products,
  onChanged,
}: {
  rid: string;
  menuId: string;
  categories: CategoryDto[];
  products: ProductDto[];
  onChanged: () => Promise<unknown>;
}) {
  const toast = useToast();
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState<string | null>(null);
  const marked = products.filter((p) => p.frozen).length;
  const key = normalizeForSearch(q.trim());
  const shown = key ? products.filter((p) => normalizeForSearch(p.name).includes(key)) : products;
  async function toggle(p: ProductDto) {
    setBusy(p.id);
    try {
      await menuApi(rid).setFrozen(menuId, p.id, !p.frozen);
      await onChanged();
    } catch (e) {
      toast(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(null);
    }
  }
  return (
    <section className="card stack" aria-labelledby="v-frozen" style={{ gap: 12 }}>
      <h2 id="v-frozen" className="h2" style={{ margin: 0 }}>
        Produse congelate
      </h2>
      <p style={{ margin: 0 }}>
        Bifează <strong>fiecare preparat făcut din produse congelate</strong> (de exemplu cartofi prăjiți
        congelați, pește sau fructe de mare congelate, deserturi gata făcute). Legea cere ca meniul să spună
        asta clienților. Doar tu știi ce folosești în bucătărie: noi nu ghicim.
      </p>
      <span className="caption muted">
        {marked ? `${marked} din ${products.length} preparate marcate.` : "Niciun preparat marcat încă."}
      </span>
      <label className="stack" style={{ gap: 4, maxWidth: 360 }}>
        <span className="field-label">Caută preparatul</span>
        <input className="field-input" type="search" value={q} onChange={(e) => setQ(e.target.value)} />
      </label>
      <div className="frozen-list">
        {categories.map((c) => {
          const items = shown.filter((p) => p.categoryId === c.id);
          if (!items.length) return null;
          return (
            <fieldset key={c.id} className="frozen-group">
              <legend>{c.name}</legend>
              {items.map((p) => (
                <label key={p.id} className="checkline">
                  <input
                    type="checkbox"
                    checked={p.frozen}
                    disabled={busy === p.id}
                    onChange={() => void toggle(p)}
                  />
                  {p.name}
                </label>
              ))}
            </fieldset>
          );
        })}
      </div>
    </section>
  );
}
